import { apiCall } from "services/api";
import { readData } from "./CompanyDocumentsService";
export const getCurrentDocumentAccess = async () =>
  readData(await apiCall({ method: "GET", url: "/v1/admin/company-documents/access" }));
export const getAdminDocumentAccess = async (id) =>
  readData(await apiCall({ method: "GET", url: `/v1/user/administrator/${id}/company-document-access` }));
export const setAdminDocumentAccess = async (id, level) => {
  const result = readData(await apiCall({ method: "PUT", url: `/v1/user/administrator/${id}/company-document-access`, data: { level } }));
  window.dispatchEvent(new Event("company-document-access-changed"));
  return result;
};
